import { Action } from '@ngrx/store';
import * as QuoteCalculationActions from './../actions/response-quote-calculation.actions';

export type Actions = QuoteCalculationActions.Actions;

export function QuoteCalculationReducer(state = [], action: QuoteCalculationActions.Actions) {
    switch (action.type) {
        case QuoteCalculationActions.ADD_QUOTE_CALCULATION:
            return [...state, action.payload];

        // Add this case:
        case QuoteCalculationActions.REMOVE_QUOTE_CALCULATION:
            state = [];
            return state;
            

        default:
            return state;
    }
}
